
















































































































import Vue from 'vue'
import firebase from 'firebase'

export default Vue.extend({
  name: 'App',

  components: {
  },

  data: () => ({
    drawer: false,
    subTitle: null as (string | null),
    isSignedIn: false,
    displayName: null as (string | null),
    renderParams: null
  }),
  computed: {
    title (): string {
      return this.$route.meta.title
    }
  },
  methods: {
    shouldShowNavForCurrentRoute (): Boolean {
      return this.$route.meta.showNavButton
    },
    onSubTitleChange (newSubTitle: string) {
      this.subTitle = newSubTitle
    },
    login (e: any) {
      this.$router.push({ name: 'login' })
    },
    async logout (e: any) {
      e.stopPropagation()
      await firebase.auth().signOut()
      this.$router.push({ name: 'home' })
    },
    redirectIfError (errorCode: number | null) {
      if (errorCode === 404 && this.$route.name !== 'error') {
        this.$router.push({ name: 'error', query: { requestedUrl: this.$route.fullPath } })
      }
    }
  },
  async created () {
    this.$store.watch(
      (state, getters) => state.errorCode,
      (newValue, oldValue) => {
        this.redirectIfError(newValue)
      }
    )

    // set up firebase auth handler
    firebase.auth().onAuthStateChanged(async user => {
      if (user) {
        let idToken = await user.getIdToken()
        this.displayName = user.displayName
        this.isSignedIn = !!idToken
        if (this.isSignedIn) {
          this.$store.dispatch('setIdentity', idToken)
          this.$store.dispatch('syncMyUser')
        } else {
          this.displayName = null
          this.$store.dispatch('setIdentity', null)
        }
      } else {
        this.isSignedIn = false
        this.displayName = null
        this.$store.dispatch('setIdentity', null)
      }
    })
  }
})
